import React from "react";
import { useParams } from "react-router";

function withParams(Component) {
    return props => <Component {...props} params={useParams()} />;
}

interface ITenant {
    tenant: string;
}

interface IProps {
    params: ITenant;
}

class Sitemap extends React.Component<IProps> {
    componentDidMount() {
        let { tenant } = this.props.params;
        window.location.href = `${process.env.REACT_APP_API_URL}/jobs/${tenant}/sitemap.xml`
    }

    render(): React.ReactNode { return (<>Redirecting...</>) }
}

export default withParams(Sitemap);